import { useEffect, useRef } from 'react';

/**
 * Tracks the provided value so you can reference the previous value to perform
 * actions such as change detection.
 */
export default function usePrevious(value) {
    const previousValue = useRef();
    useEffect(() => {
        previousValue.current = value;
    });
    return previousValue.current;
}
